import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()

    if ('_ISRF_MAP' !== map.data.mapTypeCode) {
        return null
    }

    const onClick = () => map.isrf.removeBranch()

    return {
        key: 'remove-branch-from-isrf',
        label: '移除增量分支',
        onClick,
    }
}
